import {useEffect} from "react";

const StraussInRedirect = () => {

    useEffect(()=>{
        window.location.href="//onelink.to/straussin"
    },[])
    return <div> </div>

}

export default StraussInRedirect;